import React from 'react'
import { Alert } from '@mui/material'
import DocLink from './DocLink'
import { Bullet, Bullets, Page, Screenshot, Section } from './DocsComponents'

// Page/Section/Bullets/Bullet/Screenshot now live in DocsComponents.jsx so
// other modules can reuse them. Re-exported here so existing imports across
// the Command & Control pages keep working unchanged.
export { Bullet, Bullets, Page, Screenshot, Section }

export const Info = ({ children }) => (
  <Alert severity="info" variant="outlined">
    {children}
  </Alert>
)

export { DocLink }
